import { joinURL } from 'ufo';
import { useProjectApiBaseUrl } from '#layers/base';

export async function deleteMembers(ids: string[]) {
	const endpoint = joinURL(useProjectApiBaseUrl(), 'members');

	return $fetch(endpoint, {
		method: 'DELETE',
		body: JSON.stringify(ids.map((id) => ({ userId: id }))),
	});
}
